<div class="container mt-4">
  <div class="row mb-1">
    <div class="col-12">
      <h1>
        identibase Terms & Conditions
      </h1>
      <h4>Last updated: February 2025</h4>
      <p class="text-muted">
        These terms and conditions apply to all products and services delivered by identibase. These terms tell you who we are, how we will provide products or services to you, how you or we may change or end the contract, what to do if there is a problem and other important information.
      </p>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <h4 class="my-3">
        <a>1. </a>About these Terms
      </h4>
      <p>
        We are identibase (<strong>"identibase,""we," "us," or "our"</strong> refers to identibase Limited). Our company details are set out at the end of this Terms and Conditions document (these “Terms”).
      </p>
      <p>
        These Terms form an agreement between identibase and you as the user of any of our products or services (<strong>“Pet Services”</strong>) and associated website and app (<strong>“you”, “user” or “customer”</strong>). The Terms set out the terms and conditions of your use of any of the Pet Services we provide.
      </p>
      <p>
        When your order any of our Pet Services and we communicate our agreement to provide those services these Terms (or, if subsequently updated, the latest version) will apply to the agreement between us (the “‘Contract”). Please check our website for the most up to date version of these Terms.
      </p>
      <h4 class="my-3">
        <a>2. </a>Additional terms
      </h4>
      <p>
        Additional terms may apply to specific Pet Services. Where these apply, they will be communicated to you at the time of purchase and by purchasing that specific Pet Service you agree to be bound by them. However, if any additional terms conflict with these Terms, those additional terms shall prevail.
      </p>
      <h4 class="my-3">
        <a>3. </a>Eligible Individuals
      </h4>
      <p>
        To register your pet with identibase:
      </p>
      <ol type="a">
        <li>
          You must be at least 18 years of age
        </li>
        <li>
          You must have legal capacity to enter into a binding agreement such as these Terms.
        </li>
        <li>Your use of our Pet Services must not be in breach of any applicable law, statute or regulation of the United Kingdom.</li>
      </ol>
      <p>
        If you do not meet the eligibility requirements, you are not permitted to access or use our Pet Services. By purchasing or subscribing for any of our Pet Services, you represent and warrant that you meet these criteria.
      </p>
      <h4 class="my-3">
        <a>4. </a>Your identibase account
      </h4>
      <p>
        4.1 To subscribe and access any of our Pet Services, you must first create an account and submit personal information, including your name, email address and/or phone number.
      </p>
      <p>
        4.2 You agree to provide accurate, current and complete information for verification and legal purposes.
      </p>
      <p>
       4.3 The initial registration on our ‘identibase’ database is free of charge. Amendments to your address and contact numbers will be subject to your payment under one of our identibase+, identialert or identifind services.
      </p>
      <p>
        4.4 You agree to maintain the confidentiality of your account credentials including your password. We recommend choosing a strong password and changing it periodically to ensure the security of your account.
      </p>
      <p>
        4.5 You agree not to share your login details with anyone or allow others to access your account.
      </p>
      <p>
        4.6 You agree to immediately notify us at <a href="mailto:admin@identibase.co.uk"><u>admin&#64;identibase.co.uk</u></a> or on <strong>0330 9128077</strong> if you suspect any unauthorised access to or use of your account.
      </p>
      <p>
        4.7 You accept responsibility for all activities that occur under your account and acknowledge that identibase shall not be liable for any losses or damages or claims of any description resulting from any unauthorised use of your account due to your failure to secure your login credentials.
      </p>
      <p>
        4.8 identibase reserves the right to limit, suspend or terminate your account at any time, with or without notice, and without refund (where applicable) if you have breached (or we have reasonable grounds to believe you have breached) any of these Terms.
      </p>
      <h4 class="my-3">
        <a>5. </a>Subscription Options
      </h4>
      <p>
        5.1 Registering an account is free for our “basic registration” Pet Services. However, to enjoy additional features, you must subscribe and pay for one of our annual paid plans being either “identibase+” or “identialert” or “identifind” (“Paid Plans”).
      </p>
      <p>
        5.2 The basic registration features and the additional features available through our Paid Plans are set out on our website.
      </p>
      <p>
        5.3 Subscription to each of the Paid Plans will automatically renew at the end of every 12-month subscription period <strong>(“renewal date”)</strong> unless you end the contract with us prior to the renewal date in accordance with these Terms.
      </p>
      <p>
        5.4 identibase+ and identifind are paid annually for a 12-month subscription period.
      </p>
      <p>
        5.5 As an identialert subscriber you can pay for an annual subscription either annually in advance or by monthly instalments.
      </p>
      <p>
        5.6 Our Paid Plan charges are per keeper account rather than pet and non-transferable.
      </p>
      <h4 class="my-3">
        <a #B3 id="B3" name="B3">6. </a>Subscription Plans, Pricing and Changes
      </h4>
      <p>By choosing one of our Paid Plans you hereby agree to the following terms regarding payments, billing and subscription management:</p>
      <p>
        6.1 All Paid Plans require an annual subscription. We offer monthly and yearly subscription payment options.
      </p>
      <p>
        6.2 Our prices for Paid Plans (and the included features) can be found on the pricing section of our website and payment page. These prices are subject to change and any such changes will be communicated by the following means:
      </p>
      <ol type="a">
        <li>
          by notification on the pricing section of our website and payment page; and/or
        </li>
        <li>
          if you are an existing subscriber, by written notice of at least 1 month to you prior to the next renewal date for your subscription.
        </li>
      </ol>
      <p>
        6.3 The price notified to you is given inclusive of any VAT, but any changes in VAT rates during a subscription period will result in an adjustment of the price from the date such change takes effect.
      </p>
      <p>
        6.4 Failed Payments: If a payment is declined or fails for any reason, you will be notified, and we may attempt to process the payment again. If payment continues to fail in relation to any of our Paid Plans, we reserve the right to suspend the provision
        of the Pet Services applicable to the relevant plan until the outstanding fees are paid. During any such suspension period your Pet Services will be limited to our basic registration features.
      </p>
      <p>
        6.5 Billing Issues and Support. You should inform us about any billing problems or discrepancies as soon as you become aware of them. We will make every effort to assist you with any billing queries. In particular, please always contact us before
        attempting a chargeback with your bank as we may be able to assist with your subscription plan.
      </p>
      <p>
        6.6 Auto-Renewal. Your subscription will automatically renew at the end of each subscription term (monthly or yearly) unless you cancel your online account or by calling us on 0330 9128077 before the renewal date. You will be charged the current
        subscription rate at the time of renewal.
      </p>
      <p>
        6.7 By purchasing a Paid Plan, you authorise automatic billing until you cancel your subscription for that plan.
      </p>
      <p>
        6.8 Notice of auto-renewal will be sent to your account email address detailing the price plan, applicable charges, subscription period and cancellation method not less than 1 month before the next renewal date.
      </p>
      <p>
        6.9 If you have purchased your Paid Plan under a discounted promotional price, please note that your Pet Services subscription will automatically renew at the standard non-discounted price notified in writing at the time of renewal.
      </p>
      <p>
        6.10 This renewal process does not affect your rights to cancel at any time under these Terms.
      </p>

      <h4 class="my-3">
        <a>7. </a>Cancellation.
      </h4>
      <p>
        7.1 <strong>How to end the contract with us</strong>
      </p>
      <p>
        You may cancel your subscription at any time by calling us on 0330 912 8077 or emailing us at <a href="mailto:admin@identibase.co.uk"><u>admin&#64;identibase.co.uk</u></a>, subject to the following conditions:
      </p>
      <ol type="a">
        <li>
          If you cancel an annually paid subscription before the end of your next renewal date, you will retain access to the service until that next renewal date. You are aware that refunds are not issued for partial months of service.
        </li>
        <li>
          If you cancel a monthly paid subscription prior to the next renewal date, we reserve the right to charge and collect the remaining balance of the annual subscription that would (but for your cancellation) have been payable up to the next
          renewal date. No refunds or prorated adjustments will be provided for early termination. By subscribing, you acknowledge and agree to this obligation.
        </li>
      </ol>
      <p>
        7.2 If we accept and process your order for any of our Pet Services where a pricing error is obvious and unmistakeable and could reasonably have been recognised by you as a mispricing, we may end the contract, refund you any sums you have paid
        (and, if applicable, require the return of any goods provided to you).
      </p>
      <p><strong>
        LEGAL NOTICE: If your pet is registered with us and you wish to end your Paid Plan with us, then it is your legal duty to either make sure that your pet remains registered with us using our basic registration service OR is
        registered with another microchip database from the end of your subscription plan or basic registration with us. It is also your responsibility to keep your registered contact information on your account (and card billing information
        for renewal purposes) accurate and up to date at all times. You acknowledge that Identibase may be unable to provide you with all or some of our Pet Services if you do not do so.
      </strong></p>
      <p>
        7.3 <strong>We may end the contract if you break it.</strong> We may end the contract or
        subscription for any Pet Services at any time by writing to you if:
      </p>
      <ol type="a">
        <li>
          you do not make any payment to us when it is due, and you still do not make payment within 7 days of us reminding you that payment is due;
        </li>
        <li>
          you do not, within a reasonable time of us asking for it, provide us with information that is necessary for us to provide the product or services;
        </li>
        <li>
          you do not, within a reasonable time, allow us to deliver the product or services to you or collect them from us;
        </li>
      </ol>
      <p>
        7.4 <strong>You must compensate us if you break the contract.</strong> If we end the contract in the situations set out in clause 7.2 we will refund any money you have paid in
        advance for any Pet Services we have not provided but we may deduct or charge you reasonable compensation for the net costs we will incur as a result of your breaking the contract.
      </p>
      <h4 class="my-3">
        <a>8. </a>Payment Processing.
      </h4>
      <p>
        8.1 All payments processed on our website, subscriptions and relevant products, are handled securely by our third-party payment processors.
      </p>
      <p>
        8.2 By initiating payments for our Pet Services, you authorise us and our third-party payment processors to charge the applicable subscription fees to your designated payment method.
      </p>
      <p>
        8.3 You warrant to us that you own the payment method submitted or that the owner permits you to use it.
      </p>
      <p>
        8.4 You further warrant that your payment method contains sufficient funds to cover the applicable fees for your plan.
      </p>
      <p>
        8.5 You also agree that we and/or our third-party payment processors may store and use your payment method information in order to complete each auto-renewal of your subscription.
      </p>
      <h4 class="my-3">
        <a>9. </a>Our responsibility for loss or damage suffered by you.
      </h4>
      <p>
        <a>9.1 </a><strong>We are responsible to you for foreseeable loss and damage caused by us.</strong> If we fail to comply with these Terms, we are responsible for loss or damage you
        suffer that is a foreseeable result of our breaking this contract or our failing to use reasonable care and skill, but we are not responsible for any loss or damage that is
        not foreseeable. Loss or damage is foreseeable if either it is obvious that it will happen or if, at the time the contract was made, both we and you knew it might happen, for example, if you discussed it with us during the sales process.
      </p>
      <p>
        9.2 <strong>We do not exclude or limit in any way our liability to you where it would be unlawful to do so.</strong> This includes liability for death or personal injury caused by our
        negligence or the negligence of our employees, agents or subcontractors; for fraud or fraudulent misrepresentation; or for breach of your legal rights in relation to the Pet Services.
      </p>
      <p>
        9.3 We are not responsible for delays or disruptions affecting any Pet Services which are outside of our control. If they are affected by an event outside of our control, then
          we will contact you as soon as possible to let you know and we will take steps to minimise the effect of the event. Provided we do this we will not be liable for delays caused by the event.
      </p>
      <h4 class="my-3">
        <a>10. </a>How we may use your personal information
      </h4>
       <h6><a href="https://www.identibase.co.uk/privacy">Click here to visit the privacy policy</a></h6>
      <h4 class="my-3">
        <a>11. </a>Other important terms
      </h4>
      <p>
        11.1 <strong>We may transfer this agreement to someone else.</strong> We may transfer our rights and obligations under these terms to another organisation. We will always tell
        you in writing if this happens and we will ensure that the transfer will not affect your rights under the contract.
      </p>
      <p>
        11.2 <strong>You need our consent to transfer your rights to someone else.</strong> You may only transfer your rights or your obligations under these terms to another person if we agree to this in writing.
      </p>
      <p>
        11.3 <strong>Nobody else has any rights under this contract.</strong> This contract is between <strong>You</strong> and <strong>Us</strong>. No other person shall have any rights to enforce any of its terms.
      </p>
      <p>11.4 <strong>If a court finds part of this contract illegal, the rest will continue in force.</strong> Each of the paragraphs of these terms operates separately. If any court or
        relevant authority decides that any of them are unlawful, the remaining paragraphs will remain in full force and effect.
      </p>
      <p>
        11.5 <strong>Even if we delay in enforcing this contract, we can still enforce it later.</strong> If we do not insist immediately that you do anything you are required to do under these
        terms, or if we delay in taking steps against you in respect of your breaking this contract, that will not mean that you do not have to do those things and it will not prevent us taking steps against you at a later date. For example, if you miss a
        payment and we do not chase you, but we continue to provide the Pet Services, we can still require you to make the payment at a later date.
      </p>
      <p>
        11.6 <strong>Which laws apply to this contract and where you may bring legal proceedings if you are a consumer.</strong> These terms are governed by English law, and you can bring legal proceedings in respect of the relevant Pet Services in the
        English courts. If you live in Scotland, you can bring legal proceedings in respect of the relevant Pet Services in either the Scottish or the English courts. If you live in
        Northern Ireland, you can bring legal proceedings in respect of the relevant Pet Services in either the Northern Irish or the English courts.
      </p>
      <h4 class="my-3">
        <a>12. </a>Additional Terms for products or Pet Services
      </h4>
      <p>
        12.1 Additional terms apply for specific products, including, but not limited to Tags and PitPat GPS trackers.
      </p>
      <p>
        12.2 If we cannot accept your order, we will inform you of this and refund you your payment for the relevant Pet Services you ordered.
      </p>
      <p>
        12.3 We do not accept orders from outside the UK.
      </p>
      <p>
        12.4 The images of the products on our website are for illustrative purposes only. Although we have made every effort to display the colours accurately, we cannot
        guarantee that a device's display of the colours accurately reflects the colour of the products. Your product may vary slightly from those images.
      </p>
      <p>
        12.5 The packaging of the product may vary from that shown in images on our website.
      </p>
      <p>
        12.6 We reserve the right to amend the features of any of our Pet Services if required to do so to reflect changes in relevant laws and regulatory requirements or
        best industry practice; and to implement minor technical adjustments and improvements, for example to address a security threat.
      </p>
      <p>
        12.7 It is your responsibility to ensure that the shipping address is accurate. identibase is not liable for lost or delayed shipments due to incorrect shipping information.
      </p>
      <p>
        12.8 if you purchase any good or services from any of our partners (whether via our website or a link provided by us to you for this purpose or by any means), your purchase will be subject to the relevant partner’s terms of sale and any personal
        information they collect relating to you will be subject to their privacy policy. Your partner purchases do not form part of your Pet Services contract with us and you acknowledge that identibase accepts no liability for any claims arising from any
        partner contracts you may enter.
      </p>
      <p>
        <strong>Summary of your key legal rights</strong>
      </p>
      
      <h4 class="my-3">
        13. Who we are and how to contact us
      </h4>
      <p>
        13.1 <strong>Who we are.</strong> We are identibase Limited a company registered in England and Wales. Our company registration number is 12960490 and our registered office is at
        Moorside, Monks Cross Drive, Huntington, York, YO32 9LB. Our registered VAT number is GB918442123.
      </p>
      <p>
        13.2 <strong>How to contact us.</strong> You call our customer service team at 0330 9128077 or by writing to us at <a href="mailto:admin@identibase.co.uk"><u>admin&#64;identibase.co.uk</u></a>
      </p>
      <p>
        13.3 <strong>How we may contact you.</strong> If we have to contact you we will do so by telephone or by writing to you at the email address or postal address you provided to us.
      </p>
      <p>
        13.4 <strong>"Writing" includes emails.</strong> When we use the words "writing" or "written" in these terms, this includes emails.
      </p>
    </div>
  </div>
</div>
